<div class="min-h-screen bg-white">

  <!-- Loading -->
  <div *ngIf="isLoading" class="flex items-center justify-center py-32">
    <div class="w-10 h-10 border-4 border-[#600b0b] border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- Product Detail -->
  <div *ngIf="!isLoading && onSale?.id">

    <!-- ═══ DESKTOP LAYOUT ═══ -->
    <div class="hidden lg:block max-w-[1400px] mx-auto px-6 pt-4 pb-6">
      <div class="flex gap-0">

        <!-- LEFT PANEL (desktop) -->
        <div class="w-[58%] pr-6">
          <div class="flex gap-2">
            <!-- Sidebar thumbnails -->
            <div class="flex flex-col gap-1.5 w-[60px] shrink-0 pt-1">
              <div *ngFor="let item of layoutSpaceFrames; let i = index" (click)="selectImage(i)"
                class="relative cursor-pointer border rounded p-px transition-all"
                [class]="productSubType === item?.type ? 'border-[#600b0b] border-2' : 'border-gray-200 hover:border-gray-300'">
                <img [src]="item?.image_path" class="w-full h-[52px] object-cover"
                  (error)="$any($event.target).style.display='none'" />
                <div *ngIf="productSubType === item?.type"
                  class="absolute -top-1 -right-1 w-4 h-4 bg-[#600b0b] rounded-full flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
              </div>
              <div *ngIf="showUploadSection" (click)="showFramePreview()"
                class="relative cursor-pointer border rounded p-px transition-all"
                [class]="productSubType === 'frame-preview' ? 'border-[#600b0b] border-2' : 'border-gray-200'">
                <!-- Show uploaded image if available, otherwise show icon -->
                <img *ngIf="image_path" [src]="image_path" class="w-full h-[52px] object-cover" />
                <div *ngIf="!image_path" class="w-full h-[52px] bg-gray-50 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#bbb" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                </div>
                <div *ngIf="productSubType === 'frame-preview'"
                  class="absolute -top-1 -right-1 w-4 h-4 bg-[#600b0b] rounded-full flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
              </div>
              <ng-container *ngIf="showWallImages">
                <div *ngFor="let room of roomImages" (click)="showRoomPreview(room)"
                  class="cursor-pointer border rounded p-px transition-all"
                  [class]="productSubType === room.type ? 'border-[#600b0b] border-2' : 'border-gray-200'">
                  <img [src]="room.thumb" class="w-full h-[52px] object-cover" (error)="$any($event.target).style.display='none'" />
                </div>
              </ng-container>
            </div>

            <!-- Main preview (desktop) -->
            <div class="flex-1 flex items-center justify-center min-h-[420px]">
              <ng-container *ngTemplateOutlet="mainPreview"></ng-container>
            </div>
          </div>

          <!-- About (desktop) -->
          <div *ngIf="onSale?.description" class="mt-6 border-t border-gray-100 pt-4">
            <h3 class="text-[14px] font-bold text-black" style="font-family: 'Roboto', sans-serif;">About This Product</h3>
            <p class="mt-2 text-[12px] text-gray-600 leading-relaxed" style="font-family: 'Roboto', sans-serif;">{{ onSale?.description }}</p>
          </div>
        </div>

        <!-- RIGHT PANEL (desktop) -->
        <div class="w-[42%] border-l border-gray-100 pl-6 pt-2" style="font-family: 'Roboto', sans-serif;">
          <ng-container *ngTemplateOutlet="rightPanel"></ng-container>
        </div>
      </div>
    </div>

    <!-- ═══ MOBILE LAYOUT ═══ -->
    <div class="lg:hidden" style="font-family: 'Roboto', sans-serif;">

      <!-- Image area: LEFT thumbnails + RIGHT main image (same as desktop) -->
      <div class="flex gap-1.5 px-2 pt-2">
        <!-- Vertical thumbnail sidebar (mobile) -->
        <div class="flex flex-col gap-1 w-[48px] shrink-0">
          <div *ngFor="let item of layoutSpaceFrames; let i = index" (click)="selectImage(i)"
            class="relative cursor-pointer border rounded p-px"
            [class]="productSubType === item?.type ? 'border-[#600b0b] border-2' : 'border-gray-200'">
            <img [src]="item?.image_path" class="w-full h-[42px] object-cover"
              (error)="$any($event.target).style.display='none'" />
            <div *ngIf="productSubType === item?.type"
              class="absolute -top-1 -right-1 w-3.5 h-3.5 bg-[#600b0b] rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
          </div>
          <div *ngIf="showUploadSection" (click)="showFramePreview()"
            class="relative cursor-pointer border rounded p-px"
            [class]="productSubType === 'frame-preview' ? 'border-[#600b0b] border-2' : 'border-gray-200'">
            <img *ngIf="image_path" [src]="image_path" class="w-full h-[42px] object-cover" />
            <div *ngIf="!image_path" class="w-full h-[42px] bg-gray-50 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#bbb" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            </div>
            <div *ngIf="productSubType === 'frame-preview'"
              class="absolute -top-1 -right-1 w-3.5 h-3.5 bg-[#600b0b] rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
          </div>
          <ng-container *ngIf="showWallImages">
            <div *ngFor="let room of roomImages" (click)="showRoomPreview(room)"
              class="cursor-pointer border rounded p-px"
              [class]="productSubType === room.type ? 'border-[#600b0b] border-2' : 'border-gray-200'">
              <img [src]="room.thumb" class="w-full h-[42px] object-cover" (error)="$any($event.target).style.display='none'" />
            </div>
          </ng-container>
        </div>

        <!-- Main image (mobile) -->
        <div class="flex-1 flex items-center justify-center min-h-[220px]">
          <ng-container *ngTemplateOutlet="mainPreview"></ng-container>
        </div>
      </div>

      <!-- Upload (moved above Add to Cart on mobile) -->
      <div *ngIf="showUploadSection" class="px-3 py-3 border-b border-gray-100">
        <div class="flex items-start gap-2 flex-wrap">
          <button (click)="onAddPhoto($event)"
            class="w-[85px] h-[100px] bg-gray-50 rounded flex flex-col items-center justify-center gap-1 border border-gray-200 hover:bg-gray-100 cursor-pointer shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#bbb" stroke-width="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            <span class="text-[9px] text-gray-500 font-medium uppercase leading-tight text-center">Upload<br>Image</span>
          </button>
          <div *ngFor="let photo of my_photos; let i = index" class="relative shrink-0">
            <img [src]="photo" class="w-[55px] h-[65px] object-cover rounded cursor-pointer"
              [class]="image_path === photo ? 'border-2 border-[#600b0b]' : 'border border-gray-200'"
              (click)="onPhoto($event, i)" />
            <button (click)="onRemovePhoto($event, i)"
              class="absolute -top-1 -right-1 w-3.5 h-3.5 bg-red-500 text-white rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Price + BUY NOW / ADD TO CART bar -->
      <div class="px-3 py-2.5 bg-white">
        <div class="flex items-center justify-between mb-1.5">
          <div>
            <span class="text-[15px] font-bold text-black">&#8377;{{ salePrice | number:'1.2-2' }}</span>
            <p class="text-[9px] text-gray-400">Excluding shipping fee</p>
          </div>
        </div>
        <div class="flex gap-1.5">
          <button (click)="onBuyNow()"
            class="flex-1 bg-[#600b0b] text-white py-2.5 rounded font-bold text-[10px] uppercase tracking-[0.15em] flex items-center justify-center gap-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            BUY NOW
          </button>
          <button (click)="onAddToCart()"
            class="flex-1 bg-[#600b0b] text-white py-2.5 rounded font-bold text-[10px] uppercase tracking-[0.15em] flex items-center justify-center gap-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            ADD TO CART
          </button>
        </div>
      </div>

      <!-- Title + Details -->
      <div class="px-3 py-3 border-y border-gray-100">
        <div class="flex items-start justify-between">
          <h1 class="text-[14px] font-bold text-black capitalize leading-snug flex-1">{{ onSale?.title }}</h1>
          <div class="flex items-center gap-2 ml-2 shrink-0">
            <button (click)="onToggleWishlist()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                [attr.fill]="isInWishlist() ? '#600b0b' : 'none'" stroke="#600b0b" stroke-width="1.5">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
              </svg>
            </button>
            <button (click)="onShare()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5">
                <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="mt-2.5 space-y-[8px]">
          <div class="flex justify-between"><span class="text-[11px] text-gray-400">Product</span><span class="text-[11px] text-black">{{ onSale?.product?.name || 'Print & Frame' }}</span></div>
          <div *ngIf="onSale?.print_type?.name || onSale?.print_type" class="flex justify-between"><span class="text-[11px] text-gray-400">Print Type</span><span class="text-[11px] text-black">{{ onSale?.print_type?.name || onSale?.print_type }}</span></div>
          <div *ngIf="onSale?.print_surface?.display_name || onSale?.print_surface?.name" class="flex justify-between"><span class="text-[11px] text-gray-400">Print Surface</span><span class="text-[11px] text-black">{{ onSale?.print_surface?.display_name || onSale?.print_surface?.name }}</span></div>
          <div *ngIf="frameName" class="flex justify-between"><span class="text-[11px] text-gray-400">Frame Type & Size</span><span class="text-[11px] text-black">{{ frameName }}</span></div>
          <div *ngIf="mount1?.name && onSale?.mount1_size" class="flex justify-between"><span class="text-[11px] text-gray-400">Top Mat & Size</span><span class="text-[11px] text-black">{{ mount1.name }} ({{ onSale.mount1_size }}")</span></div>
          <div *ngIf="mount2?.name && onSale?.mount2_size" class="flex justify-between"><span class="text-[11px] text-gray-400">Second Mat & Size</span><span class="text-[11px] text-black">{{ mount2.name }} ({{ onSale.mount2_size }}")</span></div>
          <div *ngIf="mount3?.name && onSale?.mount3_size" class="flex justify-between"><span class="text-[11px] text-gray-400">Third Mat & Size</span><span class="text-[11px] text-black">{{ mount3.name }} ({{ onSale.mount3_size }}")</span></div>
          <div *ngIf="onSale?.glass?.name" class="flex justify-between"><span class="text-[11px] text-gray-400">Glass Type</span><span class="text-[11px] text-black">{{ onSale.glass.name }}</span></div>
          <div *ngIf="printSize" class="flex justify-between"><span class="text-[11px] text-gray-400">Print Size</span><span class="text-[11px] text-black">{{ printSize }} (Inch)</span></div>
          <div *ngIf="finalSize" class="flex justify-between"><span class="text-[11px] text-gray-400">{{ onSale?.product_type?.slug === 'canvas' ? 'Canvas Art Size' : 'Final Frame Size' }}</span><span class="text-[11px] text-black">{{ finalSize }} (Inch)</span></div>
          <div class="flex justify-between items-start">
            <span class="text-[11px] text-gray-400">Price</span>
            <span class="text-[11px] text-right">
              <span *ngIf="discountPercent > 0" class="line-through text-gray-400 mr-1">&#8377;{{ finalPrice | number:'1.2-2' }}</span>
              <span class="text-[#600b0b] font-bold">&#8377;{{ salePrice | number:'1.2-2' }}</span>
              <br *ngIf="discountPercent > 0"><span *ngIf="discountPercent > 0" class="text-[9px] text-gray-400">({{ discountPercent }}% OFF)</span>
            </span>
          </div>
        </div>
      </div>

      <!-- Customize Frames -->
      <div *ngIf="framesData.length > 0" class="px-3 py-3 border-b border-gray-100">
        <h3 class="text-[12px] font-bold text-black mb-2">Customize Frames</h3>
        <div class="flex gap-2 flex-wrap">
          <div *ngFor="let f of framesData" (click)="selectFrame(f)" class="cursor-pointer text-center">
            <div class="relative w-[55px] h-[55px] border rounded overflow-hidden bg-gray-50"
              [class]="selectedFrameId === f.id ? 'border-[#600b0b] border-2' : 'border-gray-200'">
              <img [src]="f.L_frame_image || f.whole_frame_image || f.image" class="w-full h-full object-contain p-0.5"
                (error)="$any($event.target).src = 'assets/images/placeholder.png'" />
              <div *ngIf="selectedFrameId === f.id"
                class="absolute -top-0.5 -right-0.5 w-3 h-3 bg-green-600 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
            </div>
            <p class="mt-0.5 text-[7px] text-gray-400 max-w-[55px] truncate">{{ f.frame_name || f.name }}</p>
          </div>
        </div>
      </div>

      <!-- About -->
      <div *ngIf="onSale?.description" class="px-3 py-3">
        <h3 class="text-[13px] font-bold text-black">About This Product</h3>
        <p class="mt-1.5 text-[11px] text-gray-600 leading-relaxed">{{ onSale?.description }}</p>
      </div>
    </div>

  </div>

  <!-- Not found -->
  <div *ngIf="!isLoading && !onSale?.id" class="text-center py-32">
    <p class="text-gray-500 text-sm">Product not found.</p>
    <a routerLink="/print-frame/featured-frames" class="mt-4 inline-block bg-[#600b0b] text-white px-6 py-2.5 rounded-lg text-xs font-bold uppercase tracking-wider hover:bg-[#8c1c1c]">
      Back to Featured Frames
    </a>
  </div>

</div>

<!-- ═══ SHARED: Main Preview (reused in desktop + mobile) ═══ -->
<ng-template #mainPreview>
  <ng-container *ngFor="let item of layoutSpaceFrames">
    <img *ngIf="productSubType === item?.type" [src]="item?.image_path" [alt]="onSale?.title"
      class="max-h-[460px] lg:max-h-[460px] max-w-full object-contain"
      (error)="$any($event.target).src = 'assets/images/placeholder.png'" />
  </ng-container>
  <div *ngIf="productSubType === 'frame-preview'" class="inline-block">
    <div [style.border-width.px]="frameBorderWidth" [style.border-image]="frameBorderImage"
         style="border-style: solid; display: inline-block;">
      <div [style.padding.px]="mat1Padding" [style.background]="mount1Background" [style.border-radius]="isOvalShape ? '50%' : '0'">
        <div [style.padding.px]="mat2Padding" [style.background]="mount2Background" [style.border-radius]="isOvalShape ? '50%' : '0'">
          <div [style.padding.px]="mat3Padding" [style.background]="mount3Background" [style.border-radius]="isOvalShape ? '50%' : '0'">
            <img [src]="currentPhotoInFrame" [alt]="onSale?.title" [style.height]="printSizeH"
              style="display: block; object-fit: contain;" [style.border-radius]="isOvalShape ? '50%' : '0'"
              (error)="$any($event.target).src = 'assets/images/placeholder.png'" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="showWallImages">
    <div *ngFor="let room of roomImages">
      <div *ngIf="productSubType === room.type" class="relative inline-block">
        <img [src]="room.full" class="max-h-[420px] object-contain" />
        <div class="absolute" style="top: 20%; left: 30%; transform: translate(-50%, -50%);">
          <div [style.border-width.px]="frameBorderWidth / 2" [style.border-image]="frameBorderImage" style="border-style: solid; display: inline-block;">
            <div [style.padding.px]="mat1Padding / 2" [style.background]="mount1Background">
              <img [src]="currentPhotoInFrame" [style.height]="printSizeHRoom" style="display: block; object-fit: contain;" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<!-- ═══ SHARED: Right Panel content (desktop only) ═══ -->
<ng-template #rightPanel>
  <!-- Title + Actions -->
  <div class="flex items-start justify-between">
    <h1 class="text-[15px] font-bold text-black capitalize leading-snug flex-1">{{ onSale?.title }}</h1>
    <div class="flex items-center gap-2 ml-3 shrink-0">
      <button (click)="onToggleWishlist()" class="hover:scale-110 transition-transform">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
          [attr.fill]="isInWishlist() ? '#600b0b' : 'none'" stroke="#600b0b" stroke-width="1.5">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
      </button>
      <button (click)="onShare()" class="hover:scale-110 transition-transform">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5">
          <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
      </button>
    </div>
  </div>
  <!-- Details -->
  <div class="mt-3 space-y-[10px]">
    <div class="flex justify-between"><span class="text-[12px] text-gray-400">Product</span><span class="text-[12px] text-black">{{ onSale?.product?.name || 'Print & Frame' }}</span></div>
    <div *ngIf="onSale?.print_type?.name || onSale?.print_type" class="flex justify-between"><span class="text-[12px] text-gray-400">Print Type</span><span class="text-[12px] text-black">{{ onSale?.print_type?.name || onSale?.print_type }}</span></div>
    <div *ngIf="onSale?.print_surface?.display_name || onSale?.print_surface?.name" class="flex justify-between"><span class="text-[12px] text-gray-400">Print Surface</span><span class="text-[12px] text-black">{{ onSale?.print_surface?.display_name || onSale?.print_surface?.name }}</span></div>
    <div *ngIf="frameName" class="flex justify-between"><span class="text-[12px] text-gray-400">Frame Type & Size</span><span class="text-[12px] text-black">{{ frameName }}</span></div>
    <div *ngIf="mount1?.name && onSale?.mount1_size" class="flex justify-between"><span class="text-[12px] text-gray-400">Top Mat & Size</span><span class="text-[12px] text-black">{{ mount1.name }} ({{ onSale.mount1_size }}")</span></div>
    <div *ngIf="mount2?.name && onSale?.mount2_size" class="flex justify-between"><span class="text-[12px] text-gray-400">Second Mat & Size</span><span class="text-[12px] text-black">{{ mount2.name }} ({{ onSale.mount2_size }}")</span></div>
    <div *ngIf="mount3?.name && onSale?.mount3_size" class="flex justify-between"><span class="text-[12px] text-gray-400">Third Mat & Size</span><span class="text-[12px] text-black">{{ mount3.name }} ({{ onSale.mount3_size }}")</span></div>
    <div *ngIf="onSale?.glass?.name" class="flex justify-between"><span class="text-[12px] text-gray-400">Glass Type</span><span class="text-[12px] text-black">{{ onSale.glass.name }}</span></div>
    <div *ngIf="printSize" class="flex justify-between"><span class="text-[12px] text-gray-400">Print Size</span><span class="text-[12px] text-black">{{ printSize }} (Inch)</span></div>
    <div *ngIf="finalSize" class="flex justify-between"><span class="text-[12px] text-gray-400">{{ onSale?.product_type?.slug === 'canvas' ? 'Canvas Art Size' : 'Final Frame Size' }}</span><span class="text-[12px] text-black">{{ finalSize }} (Inch)</span></div>
    <div class="flex justify-between items-start">
      <span class="text-[12px] text-gray-400">Price</span>
      <span class="text-[12px] text-right">
        <span *ngIf="discountPercent > 0" class="line-through text-gray-400 mr-1">&#8377;{{ finalPrice | number:'1.2-2' }}</span>
        <span class="text-[#600b0b] font-bold">&#8377;{{ salePrice | number:'1.2-2' }}</span>
        <br *ngIf="discountPercent > 0"><span *ngIf="discountPercent > 0" class="text-[10px] text-gray-400">({{ discountPercent }}% OFF)</span>
      </span>
    </div>
  </div>
  <!-- Upload -->
  <div *ngIf="showUploadSection" class="border-t border-gray-100 mt-3 pt-3">
    <div class="flex items-start gap-2.5 flex-wrap">
      <button (click)="onAddPhoto($event)"
        class="w-[110px] h-[130px] bg-gray-50 rounded-lg flex flex-col items-center justify-center gap-1.5 border border-gray-200 hover:bg-gray-100 hover:border-[#600b0b] cursor-pointer shrink-0 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#bbb" stroke-width="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
        <span class="text-[10px] text-gray-500 font-semibold uppercase tracking-wide leading-tight text-center">Upload<br>Image</span>
      </button>
      <div *ngFor="let photo of my_photos; let i = index" class="relative shrink-0">
        <img [src]="photo" class="w-[65px] h-[80px] object-cover rounded cursor-pointer"
          [class]="image_path === photo ? 'border-2 border-[#600b0b]' : 'border border-gray-200'"
          (click)="onPhoto($event, i)" />
        <button (click)="onRemovePhoto($event, i)"
          class="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white rounded-full flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
    </div>
  </div>
  <!-- Frames -->
  <div *ngIf="framesData.length > 0" class="border-t border-gray-100 mt-3 pt-3">
    <h3 class="text-[12px] font-bold text-black mb-2">Customize Frames</h3>
    <div class="flex gap-2.5 flex-wrap">
      <div *ngFor="let f of framesData" (click)="selectFrame(f)" class="cursor-pointer text-center">
        <div class="relative w-[70px] h-[70px] border rounded overflow-hidden bg-gray-50"
          [class]="selectedFrameId === f.id ? 'border-[#600b0b] border-2' : 'border-gray-200'">
          <img [src]="f.L_frame_image || f.whole_frame_image || f.image" class="w-full h-full object-contain p-0.5"
            (error)="$any($event.target).src = 'assets/images/placeholder.png'" />
          <div *ngIf="selectedFrameId === f.id"
            class="absolute -top-0.5 -right-0.5 w-[14px] h-[14px] bg-green-600 rounded-full flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
        </div>
        <p class="mt-0.5 text-[9px] text-gray-400 max-w-[70px] truncate">{{ f.frame_name || f.name }}</p>
      </div>
    </div>
  </div>
  <!-- Price + Buttons -->
  <div class="border-t border-gray-100 mt-3 pt-3">
    <span class="text-[16px] font-bold text-black">&#8377;{{ salePrice | number:'1.2-2' }}</span>
    <p class="text-[9px] text-gray-400">Excluding shipping fee</p>
    <div class="mt-3 space-y-1.5">
      <button (click)="onBuyNow()"
        class="w-full bg-[#600b0b] text-white py-2.5 rounded font-bold text-[11px] uppercase tracking-[0.2em] hover:bg-[#8c1c1c] flex items-center justify-center gap-1.5">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
        BUY NOW
      </button>
      <button (click)="onAddToCart()"
        class="w-full bg-[#600b0b] text-white py-2.5 rounded font-bold text-[11px] uppercase tracking-[0.2em] hover:bg-[#8c1c1c] flex items-center justify-center gap-1.5">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
        ADD TO CART
      </button>
      <!-- <a *ngIf="showEditProduct" [routerLink]="['/product-customization']" [queryParams]="getEditQueryParams()"
        class="w-full block text-center border border-[#c49a6c] text-[#c49a6c] py-2.5 rounded font-bold text-[11px] uppercase tracking-[0.2em]">
        Edit Product
      </a> -->
    </div>
  </div>
</ng-template>
